import { render, staticRenderFns } from "./BaseLoadingContent.vue?vue&type=template&id=4e52d846&scoped=true"
import script from "./BaseLoadingContent.vue?vue&type=script&lang=js"
export * from "./BaseLoadingContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e52d846",
  null
  
)

export default component.exports